import { createRouter, createWebHashHistory } from 'vue-router';
import login from '../login.vue';
import home from '../home.vue';

const routes = [
    {
        path: '/',
        name: 'login',
        component: login
    },
    {
        path: '/home',
        name: 'home',
        component: home
    }
];

const router = createRouter({
    history: createWebHashHistory(),
    routes
});

export default router;
